var exports = {
  "BN": "VoiceGridLayout.module__gridViewport___YnFreW",
  "Om": "VoiceGridLayout.module__gridViewportCompact___YnFreW",
  "Vg": "VoiceGridLayout.module__grid___YnFreW",
  "ux": "VoiceGridLayout.module__gridItem___YnFreW",
};

module.exports = exports;
